// Base on jump.js: https://github.com/callmecavs/jump.js
// jump.js won't work for scrolling inside an element: https://github.com/callmecavs/jump.js/issues/50

// https://github.com/jaxgeller/ez.js/blob/master/ez.js
// t: current time, b: beginning value, c: change in value, d: duration
const easeOutCirc = (t, b, c, d) => c * Math.sqrt(1 - (t = t / d - 1) * t) + b;

const scroller = () => {
	let timeElapsed;
	let timeStart;
	let timeDuration;

	let startY;
	let targetY;

	let isWindowScrolling;

	let rafId = null;

	function updateScroll(scrollingElement, scrollTop) {
		if (isWindowScrolling) {
			scrollingElement.scrollTo(0, scrollTop);
		} else {
			scrollingElement.scrollTop = scrollTop;
		}
	}

	function loop(scrollingElement) {
		const now = Date.now();

		timeElapsed = now - timeStart;

		const scrollAmount = easeOutCirc(timeElapsed, 0, targetY, timeDuration);
		const scrollTop = startY + scrollAmount;

		updateScroll(scrollingElement, scrollTop);

		if (timeElapsed < timeDuration) {
			rafId = requestAnimationFrame(() => loop(scrollingElement));
		} else {
			updateScroll(scrollingElement, startY + targetY);

			cancelAnimationFrame(rafId);
		}
	}

	function scrollTo(
		selector,
		scrollingElement = window,
		{ duration = 500, offset = 0 } = {},
	) {
		const targetEl = document.querySelector(selector);

		if (!targetEl) {
			return;
		}

		isWindowScrolling = scrollingElement === window;
		timeStart = Date.now();
		timeDuration = duration;

		// `scrollTop` for nodes, `scrollY` for `window`
		startY = isWindowScrolling
			? scrollingElement.scrollY || scrollingElement.pageYOffset
			: scrollingElement.scrollTop;

		targetY = targetEl.getBoundingClientRect().top - offset;

		cancelAnimationFrame(rafId);

		rafId = loop(scrollingElement);
	}

	return scrollTo;
};

const scrollerInstance = scroller();

export default scrollerInstance;
